import { Component, h } from 'preact';
import { TcrComboBox } from './combobox';

class TcrUserInput extends Component
{
    constructor(props)
    {
        super(props);

        this.addUser = this.addUser.bind(this);

        this.state = {
            
        }
    }

    addUser(value)
    {
        let users = [
            ...this.props.value || [],
            {
                option: value,
                value: '' 
            }
        ];
        console.log('addUser in user-input', users);
        this.props.onInput({
            target: {
                value: users //JSON.parse(JSON.stringify(users))
            }
        });
    }

    getDisplay(value, options)
    {
        //console.log(value, options);
        if (Array.isArray(options))
        {
            for (let i = 0; i< options.length; i++)
            {
                if (options[i].value === value) return options[i].display;
            }
        }
        return value;
    }

    render()
    {
        //console.log('render user-input', this.props.value);
        let options = (this.props.options || []).filter(o => 
        {
            //Filter out the users, that are already selected
            if (Array.isArray(this.props.value))
            {
                for (let user of this.props.value)
                {
                    if (user.option === o.value) return false;
                }
            }
            return true;
        });
        let values = (this.props.values || []).map(v => {
            return <option value={v.value}>{v.display}</option>;
        });
        console.log('users  --- ', this.props.value);
        let users = (this.props.value || []).map(user =>
        {
            return (
                <div class="user">
                    <div class="title">{this.getDisplay(user.option, this.props.options)}</div>
                    <select value={user.value}>
                        {values}
                    </select>
                </div>
            );
        });
        return (
            <div class="tcr-user-input">
                <div class="users">
                    {users}
                </div>
                <TcrComboBox value="" options={options} onInput={(e) => this.addUser(e.target.value)} placeholder="Benutzer hinzufügen..." />
            </div>
        );
    }
}

export { TcrUserInput };
